
import assets from './data/assets';
import music from './data/music';

let loaded = 0;
let totalToLoad = 0;
let musicTrack = -1;

const options = {
  'screen' : {
    'width': 5760,
    'height': 3240,
  },
  'randomize_music': false,
};

if(navigator.userAgent.match(/Android/i)){
  window.scrollTo(0,1);
}

const updateProgress = () => {
  loaded++;
  const percLoaded = (loaded / totalToLoad) * 100;
  const loadBar = document.getElementById('load-perc');
  loadBar.setAttribute('style', `width: ${percLoaded}%`);
  //console.log(`${loaded} / ${totalToLoad} = ${percLoaded}%`);
  if(loaded < totalToLoad) return;

  finishedLoading();
};

const finishedLoading = () => {
  const loadBar = document.getElementById('load-perc');

  const status = document.getElementById('status');
  loadBar.classList.remove('fill');
  loadBar.classList.add('bg-green');
  status.innerHTML = 'Loaded<br><p class="text-base my-4">It’s time to go find all the things to interact with and create your perfect personalized holiday fireplace.</p>';
  const loader = document.getElementById('loader');
  const okay = document.getElementById('start');
  okay.classList.remove('hidden');
  okay.addEventListener('click', (event)  => {
    loader.classList.add('opacity-0');
    loader.classList.add('pointer-events-none');
    const scene = document.getElementById('scene-holder');
    scene.classList.remove('hidden');
    playMusic(event);
    startFire();
  });
}

const playMusic = (event) => {
  event.preventDefault();
  const radio = document.getElementById('music');
  if(!radio.paused || musicTrack == -1) {
    if(musicTrack == -1) musicTrack = 0;
    radio.pause();
    toggleMusicPlayingAnimation(false);
    console.info('Stopping music track');
  } else {
    playNextTrack();
  }
};

const playNextTrack = () => {
  const radio = document.getElementById('music');
  musicTrack++;
  if(musicTrack >= music.length) musicTrack = 0;

  radio.setAttribute('src', music[musicTrack].src);
  radio.play();

  toggleMusicPlayingAnimation(true);

  console.info('Starting music track ' + musicTrack + ') ' + music[musicTrack].src);
}

const toggleMusicPlayingAnimation = (show) => {
  const music_animation = document.querySelector('.js-item-music_notes');
  if(show) {
    music_animation.classList.remove('hidden');
  } else {
    music_animation.classList.add('hidden');
  }
}

const startFire = () => {
  const fireplace = document.getElementById('sound_fireplace');
  const playingSound = '/sounds/fireplace.mp3';
  fireplace.setAttribute('src', playingSound);
  fireplace.play();
};

const createImage = (imageAsset, item, isHidden) => {
  const image = document.getElementById(item.name) ? document.getElementById(item.name) : document.createElement('img');
  image.dataset.name = item.name;
  if(imageAsset.shadow) {
    image.dataset.shadow = imageAsset.shadow;
  }
  image.setAttribute('src', imageAsset.src);
  image.setAttribute('alt', item.name);
  image.classList.add('js-item-' + item.name);
  image.classList.add('absolute');

  if(imageAsset.x) {
    image.style.left = `${ (imageAsset.x / options.screen.width) * 100 }%`;
  } else {
    image.style.left = `${ (item.x / options.screen.width) * 100 }%`;
  }

  if(imageAsset.x) {
    image.style.top = `${ (imageAsset.y / options.screen.height) * 100 }%`;
  } else {
    image.style.top = `${ (item.y / options.screen.height) * 100 }%`;
  }

  if(imageAsset.w) {
    image.style.width = `${ (imageAsset.w / options.screen.width) * 100 }%`;
  } else if(item.w) {
    image.style.width = `${ (item.w / options.screen.width) * 100 }%`;
  }

  if(imageAsset.h) {
    image.style.height = `${ (imageAsset.h / options.screen.height) * 100 }%`;
  } else if(item.h) {
    image.style.height = `${ (item.h / options.screen.height) * 100 }%`;
  }

  if(item.flicker) {
    image.classList.add('object-flicker');
  }

  if(item.mixBlendMode) image.style.mixBlendMode = item.mixBlendMode;
  if(item.filter) image.style.filter = item.filter;
  if(item.opacity) image.style.opacity = item.opacity;

  image.addEventListener('load', updateProgress);
  const scene = document.getElementById('scene-holder');
  scene.appendChild(image);

  if(isHidden) {
    image.classList.add('object-hidden');
  }

  return image;
};

const openModal = function(data) {
  const modal = document.getElementById('js-modal-image');
  modal.src = data;
  document.body.classList.add('modal-open');
};

const modal = document.getElementById('js-modal');
modal.addEventListener('click', (event) => {
  event.preventDefault();
  document.body.classList.remove('modal-open');
});

const attachListenersToImage = (image, item) => {
  image.classList.add('interactible');
  image.classList.add('pointer-cursor');

  switch(item.action) {
    case 'music':
      addMusic(image);
      break;
    case 'modal':
      createModal(image, item);
      break;
    default:
      createImageListeners(image);
  }
};

const addMusic = function(image) {
  if(options.randomize_music) musicTrack = Math.round(Math.random()*(music.length-1));
  image.addEventListener('click', playMusic);

  const radio = document.getElementById('music');
  radio.addEventListener('ended', () => {
    playNextTrack();
  });
}

const createModal = function(image, item) {
  image.addEventListener('click', () => {
    openModal(item.modal);
  });
}

const createImageListeners = function(image) {
  image.addEventListener('click', function(event) {
    event.preventDefault();
    const images = document.querySelectorAll('.js-item-' + this.dataset.name);
    let found = false;
    let showNumber = -1;
    images.forEach((image, number) => {
      image.classList.add('object-hidden');
      if(image.dataset.shadow) {
        const shadow = document.querySelector('.js-item-' + image.dataset.shadow);
        shadow.classList.add('hidden');
      }
      if(found && showNumber==-1) {
        showNumber=number;
      }
      if(image==this) {
        found = true;
        if(number == images.length-1) {
          showNumber = 0;
        }
      }
    });
    images[showNumber].classList.remove('object-hidden');
    if(images[showNumber].dataset.shadow) {
      const shadow = document.querySelector('.js-item-' + images[showNumber].dataset.shadow);
      shadow.classList.remove('hidden');
    }
  });
}

assets.forEach((item) => {
  if(item.child) {
    totalToLoad++;
    const isHidden = false;
    createImage(item.child, item.child, isHidden);
  }
  // pick a random image to show
  const visibleAsset = Math.round(Math.random()*(item.assets.length-1));
  item.assets.forEach((imageAsset, i) => {
    totalToLoad++;
    const isHidden = visibleAsset !== i;
    const image = createImage(imageAsset, item, isHidden);
    if(item.assets.length > 1 || typeof item.action != 'undefined') {
      attachListenersToImage(image, item);
    } else {
      image.classList.add('pointer-events-none');
    }
  });
});
